import React, { useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { RxCross2 } from "react-icons/rx";
import { AiOutlineSearch } from "react-icons/ai";
import {
  MdOutlineModeEditOutline,
  MdDownload,
  MdDelete,
  MdDeleteOutline,
} from "react-icons/md";
import { useGlobalContext } from "../../Contexts/GlobalContext";
import axios from "axios";
import { BASE_URL, CustomTablePagination } from "../../Utlils";
import Loader from "../../components/Loader";
import { useEffect } from "react";
import { utils, writeFile } from "xlsx";
import DeleteModal from "../../components/DeleteModal";
import {
  addMyQuestions,
  getMyQuestions,
  getQuestionLibrary,
  updateMyQuestion,
} from "../../Actions/questionsActions";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import NoData from "../../components/NoData";
import Skeleton from "../../components/Skeleton";
import { CircularProgress } from "@mui/material";

const QUESTION_TYPES = [
  "Multi Punch",
  "Single Punch",
  "Numeric - Open-end",
  "Text - Open-end",
];

const isChoiceType = (type) =>
  type === "Multi Punch" || type === "Single Punch";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 650,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: 2,
};

const Qualification = () => {
  const queryClient = useQueryClient();
  let { countryData, setSnackbar, user, getMyQuestion } = useGlobalContext();
  const [tab, setTab] = useState(0);
  const [myQuestionsPage, setMyQuestionsPage] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filters, setFilters] = useState({});
  const [debouncedMyQuestionSearchText, setDebouncedMyQuestionSearchText] =
    useState(filters?.text);
  const [myQuestionsRowsPerPage, setMyQuestionsRowsPerPage] = useState(25);

  const {
    data: libraryQuestions,
    isLoading: libraryQuestionsLoading,
    isError: libraryQuestionsError,
  } = useQuery({
    queryFn: () =>
      getQuestionLibrary(
        page,
        rowsPerPage,
        filters?.type,
        debouncedMyQuestionSearchText
      ),
    queryKey: [
      "question-library",
      page,
      rowsPerPage,
      filters?.type,
      debouncedMyQuestionSearchText,
    ],
    enabled: tab == 0,
  });
  const {
    data: myQuestions,
    isLoading: myQuestionsLoading,
    isError: myQuestionsError,
  } = useQuery({
    queryFn: () =>
      getMyQuestions(
        user?.organizationId,
        myQuestionsPage,
        myQuestionsRowsPerPage,
        filters?.type,
        debouncedMyQuestionSearchText
      ),
    queryKey: [
      "myQuestions",
      user?.organizationId,
      myQuestionsPage,
      myQuestionsRowsPerPage,
      filters?.type,
      debouncedMyQuestionSearchText,
    ],
    enabled: !!user?.organizationId && tab == 1,
  });
  const { mutateAsync: addNewQuestion } = useMutation({
    mutationFn: addMyQuestions,
    onSuccess: () => {
      queryClient.invalidateQueries(["myQuestions", user?.organizationId]);
    },
  });
  const { mutateAsync: saveQuestion, isPending: savingQuestion } = useMutation({
    mutationFn: updateMyQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries(["myQuestions", user?.organizationId]);
    },
  });
  useEffect(() => {
    const handler = setTimeout(() => {
      if (page != 0) {
        setPage(0);
      }
      setDebouncedMyQuestionSearchText(filters?.text);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filters?.text]);
  const [modalsOpen, setModalsOpen] = useState({
    preview: false,
    qualification: false,
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectRows, setSelectRows] = useState([]);

  const [previewData, setPreviewData] = useState({});
  const [createQualiPage, setCreateQualiPage] = useState(0);

  const [qualifiOptions, setQualifiOptions] = useState(["", ""]);
  const [inputData, setInputData] = useState({});
  const handleCloseModal = (e) => setDeleteModal(false);
  const handleClose = (name) => {
    setModalsOpen((prev) => ({ ...prev, [name]: false }));
    setInputData({});
    setCreateQualiPage(0);
    setQualifiOptions(["", ""]);
  };

  useEffect(() => {
    setQualifiOptions(inputData?.options ?? ["", ""]);
  }, [inputData?.options]);

  const handleOpen = (name) =>
    setModalsOpen((prev) => ({ ...prev, [name]: true }));

  const openEditQuestion = (question) => {
    if (!question?._id) return;
    setInputData({
      edit: true,
      ...question,
    });
    setQualifiOptions(
      question?.options?.length ? [...question.options] : ["", ""]
    );
    setCreateQualiPage(0);
    handleOpen("qualification");
  };

  const handleQuestionTypeChange = (nextType) => {
    setInputData((prev) => ({
      ...prev,
      questionType: nextType,
    }));
    if (isChoiceType(nextType)) {
      setQualifiOptions((prev) =>
        prev?.filter((option) => String(option || "").trim())?.length
          ? prev
          : ["", ""]
      );
    }
  };

  const buildQuestionPayload = () => {
    const {
      edit,
      _id,
      createdAt,
      updatedAt,
      __v,
      ...rest
    } = inputData || {};
    const options = isChoiceType(inputData?.questionType)
      ? (qualifiOptions || []).map((option) => String(option).trim()).filter(Boolean)
      : [];
    return {
      ...rest,
      questionName: inputData?.questionName,
      questionType: inputData?.questionType,
      questionText: inputData?.questionText,
      questionStatus: inputData?.questionStatus || "active",
      options,
    };
  };

  const validateQuestionPayload = (payload) => {
    if (!payload?.questionName?.trim()) {
      return "Please enter a qualification name.";
    }
    if (!payload?.questionType) {
      return "Please select a question type.";
    }
    if (!payload?.questionText?.trim()) {
      return "Please enter question text.";
    }
    if (isChoiceType(payload.questionType) && payload.options.length < 2) {
      return "Please add at least 2 options.";
    }
    return "";
  };

  //ADD QUALIFICATION:
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (createQualiPage === 3) {
        let data = await addNewQuestion({
          ...inputData,
          options: qualifiOptions,
          createdBy: user?.organizationId,
        });
        setSnackbar((prev) => ({
          ...prev,
          open: true,
          msg: "Question Added Successfully ",
          severity: "success",
        }));
        handleClose("qualification");
        setInputData({});
        setQualifiOptions(["", ""]);

        setModalsOpen((prev) => ({ ...prev, qualification: false }));
      } else {
        setCreateQualiPage((prev) => prev + 1);
      }
    } catch (error) {
      setSnackbar((prev) => ({
        ...prev,
        open: true,
        msg: "Something went wrong !",
        severity: "error",
      }));
    } finally {
      await getMyQuestion();
    }
  };

  //EDIT QUALIFICATION:
  const editQualification = async (e) => {
    e.preventDefault();
    const payload = buildQuestionPayload();
    const errorMessage = validateQuestionPayload(payload);
    if (errorMessage) {
      setSnackbar({
        open: true,
        msg: errorMessage,
        severity: "error",
      });
      return;
    }
    try {
      await saveQuestion({
        id: inputData?._id,
        payload,
      });
      await getMyQuestion();
      setSnackbar({
        open: true,
        msg: "Question updated successfully.",
        severity: "success",
      });
      setSelectRows([]);
      handleClose("qualification");
    } catch (error) {
      console.log(error);
      setSnackbar({
        open: true,
        msg: "Unable to update question.",
        severity: "error",
      });
    }
  };

  const renderCreateQualificationPage = () => {
    switch (createQualiPage) {
      case 0:
        return (
          <>
            <div className="flex flex-col gap-2">
              <label
                htmlFor="QualificationName"
                className="text-[#1a1a1a] text-[14px] font-[500]"
              >
                Qualification Name
              </label>
              <input
                type="text"
                required
                placeholder="Enter qualification name"
                value={inputData?.questionName}
                onChange={(e) =>
                  setInputData((prev) => ({
                    ...prev,
                    questionName: e.target.value,
                  }))
                }
                className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
              />
            </div>
            <div className="flex flex-col gap-[10px]">
              <label
                htmlFor="QualificationType"
                className="text-[#333] text-[14px] font-[500]"
              >
                Qualification Type
              </label>
              <select
                name="QualificationType"
                id="QualificationType"
                required
                value={inputData?.questionType || ""}
                onChange={(e) => handleQuestionTypeChange(e.target.value)}
                className="border border-gray-300 rounded-md pl-4 pr-10 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] font-[400] cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
              >
                <option value="" className="text-[#666] font-[400]">
                  Select Qualification Type
                </option>
                {QUESTION_TYPES.map((type) => (
                  <option value={type} key={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          </>
        );

      case 1:
        return (
          <div className="flex flex-col gap-[40px]">
            <div className="flex flex-col gap-[10px]">
              <h1 className="text-[#000] font-[500] text-[14px]">
                Question Status
              </h1>
              <div className="flex w-[40%]  items-center justify-between">
                <div className="flex items-center gap-[15px] w-2/4">
                  <input
                    type="radio"
                    name="questionStatus"
                    required
                    id="active"
                    checked={inputData?.questionStatus === "active"}
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        questionStatus: "active",
                      }))
                    }
                    className="accent-[#0226BE] w-[15px] h-[15px] "
                  />
                  <label
                    htmlFor="active"
                    className="text-[#666] text-[12px] font-[400]"
                  >
                    Active
                  </label>
                </div>
                <div className="flex items-center gap-[15px] w-2/4">
                  <input
                    type="radio"
                    name="questionStatus"
                    required
                    id="Inactive"
                    checked={inputData?.questionStatus === "inactive"}
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        questionStatus: "inactive",
                      }))
                    }
                    className="accent-[#0226BE] w-[15px] h-[15px] "
                  />
                  <label
                    htmlFor="Inactive"
                    className="text-[#666] text-[12px] font-[400]"
                  >
                    Inactive
                  </label>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-[10px]">
              <h1 className="text-[#000] font-[500] text-[14px]">
                Is Core Demographic
              </h1>
              <div className="flex w-[40%]  items-center justify-between">
                <div className="flex items-center gap-[15px] w-2/4">
                  <input
                    type="radio"
                    name="isCoreDemographic"
                    id="Yes"
                    required
                    checked={inputData?.isCoreDemographic}
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        isCoreDemographic: true,
                      }))
                    }
                    className="accent-[#0226BE] w-[15px] h-[15px] "
                  />
                  <label
                    htmlFor="Yes"
                    className="text-[#666] text-[12px] font-[400]"
                  >
                    Yes
                  </label>
                </div>
                <div className="flex items-center gap-[15px] w-2/4">
                  <input
                    type="radio"
                    name="isCoreDemographic"
                    id="No"
                    required
                    checked={inputData?.isCoreDemographic === false}
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        isCoreDemographic: false,
                      }))
                    }
                    className="accent-[#0226BE] w-[15px] h-[15px] "
                  />
                  <label
                    htmlFor="No"
                    className="text-[#666] text-[12px] font-[400]"
                  >
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <>
            <div className="flex flex-col gap-2">
              <label
                htmlFor="Country"
                className="text-[#1a1a1a] text-[14px] font-[500]"
              >
                Country
              </label>
              <input
                type="text"
                className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
                list="countryList"
                placeholder="Enter country name"
                value={inputData?.country}
                onChange={(e) =>
                  setInputData((prev) => ({ ...prev, country: e.target.value }))
                }
              />
              <datalist id="countryList">
                <option value="" selected>
                  Select Country{" "}
                </option>
                {countryData?.isLoading ? (
                  <option value="" disabled>
                    Loading Countries...
                  </option>
                ) : countryData?.error ? (
                  <option value="" disabled>
                    Error while fetching countries try refreshing the page
                  </option>
                ) : (
                  countryData?.data?.map((data, key) => (
                    <option value={data?.name} key={key}>
                      {data?.name}
                    </option>
                  ))
                )}
              </datalist>
            </div>
            <div className="flex flex-col gap-[10px]">
              <label
                htmlFor="language"
                className="text-[#333] text-[14px] font-[500]"
              >
                Select Language
              </label>
              <select
                name="language"
                id="language"
                value={inputData?.language}
                onChange={(e) =>
                  setInputData((prev) => ({
                    ...prev,
                    language: e.target.value,
                  }))
                }
                className="border border-gray-300 rounded-md pl-4 pr-10 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] font-[400] cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
              >
                <option value="" className="text-[#666] font-[400]">
                  Select Language
                </option>
                {["English", "French", "German", "Japanese", "Spanish"]?.map(
                  (data) => (
                    <option value={data}>{data}</option>
                  )
                )}
              </select>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div className="flex flex-col gap-2">
              <label
                htmlFor="QualificationQuestionText"
                className="text-[#1a1a1a] text-[14px] font-[500]"
              >
                Qualification Question Text
              </label>
              <textarea
                name="QualificationQuestionText"
                id="QualificationQuestionText"
                cols="30"
                rows="4"
                required
                value={inputData?.questionText}
                onChange={(e) =>
                  setInputData((prev) => ({
                    ...prev,
                    questionText: e.target.value,
                  }))
                }
                placeholder="Enter qualification question text"
                className="w-full border border-gray-300 rounded-md pl-4 pt-3 pr-4 pb-3 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all resize-none text-[#1a1a1a] text-[14px] hover:border-gray-400"
              ></textarea>
            </div>
            {isChoiceType(inputData?.questionType) ? (
              <div className="flex flex-col gap-[10px]">
                <label
                  htmlFor="Country"
                  className="text-[#333] text-[14px] font-[500]"
                >
                  Option Text
                </label>
                <div className="flex flex-col gap-[12px] max-h-[150px] pr-[10px] overflow-y-auto containerScroll ">
                  {qualifiOptions?.map((data, ind, arr) => (
                    <div className="flex items-center relative" key={ind}>
                      <input
                        type="text"
                        required
                        onChange={(e) => {
                          const updatedOptions = [...qualifiOptions];
                          updatedOptions[ind] = e.target.value;
                          setQualifiOptions(updatedOptions);
                        }}
                        value={data}
                        placeholder={`Enter option ${ind + 1}`}
                        className={`border border-gray-300 rounded-md pl-4 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400 ${
                          arr.length === 1 ? "w-full" : "w-[96%]"
                        } `}
                      />
                      <span
                        className={`absolute right-[0px] cursor-pointer ${
                          arr.length === 1 ? "hidden" : ""
                        }`}
                        onClick={(e) =>
                          setQualifiOptions((prev) =>
                            prev?.filter((_, inz) => inz !== ind)
                          )
                        }
                      >
                        <MdDeleteOutline color="red" size={18} />
                      </span>
                    </div>
                  ))}
                </div>
                <h3
                  className="text-[#0226BE] text-[12px] font-[400] cursor-pointer"
                  onClick={(e) => {
                    if (qualifiOptions) {
                      setQualifiOptions((prev) => [...prev, ""]);
                    } else {
                      setQualifiOptions((prev) => [""]);
                    }
                  }}
                >
                  + <span>Add More Options </span>
                </h3>
              </div>
            ) : (
              ""
            )}
          </>
        );
      default:
        return <h1>No Data</h1>;
    }
  };

  const renderOptionsEditor = () => (
    <div className="flex flex-col gap-[10px]">
      <label className="text-[#333] text-[14px] font-[500]">
        Option Text
      </label>
      <div className="flex flex-col gap-[12px] max-h-[180px] pr-[10px] overflow-y-auto containerScroll">
        {(qualifiOptions?.length ? qualifiOptions : ["", ""]).map(
          (option, ind, arr) => (
            <div className="flex items-center relative" key={ind}>
              <input
                type="text"
                required
                onChange={(e) => {
                  const updatedOptions = [...(qualifiOptions || [])];
                  updatedOptions[ind] = e.target.value;
                  setQualifiOptions(updatedOptions);
                }}
                value={option}
                placeholder={`Enter option ${ind + 1}`}
                className={`border border-gray-300 rounded-md pl-4 pr-10 py-3 focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400 ${
                  arr.length === 1 ? "w-full" : "w-full"
                }`}
              />
              <button
                type="button"
                className={`absolute right-[8px] cursor-pointer ${
                  arr.length === 1 ? "hidden" : ""
                }`}
                onClick={() =>
                  setQualifiOptions((prev) =>
                    prev?.filter((_, inz) => inz !== ind)
                  )
                }
              >
                <MdDeleteOutline color="red" size={18} />
              </button>
            </div>
          )
        )}
      </div>
      <button
        type="button"
        className="text-[#0226BE] text-[12px] font-[500] cursor-pointer w-fit"
        onClick={() =>
          setQualifiOptions((prev) => [...(prev?.length ? prev : [""]), ""])
        }
      >
        + Add More Options
      </button>
    </div>
  );

  const renderEditQualificationForm = () => (
    <>
      <div className="flex flex-col gap-2">
        <label className="text-[#1a1a1a] text-[14px] font-[500]">
          Qualification Name
        </label>
        <input
          type="text"
          required
          placeholder="Enter qualification name"
          value={inputData?.questionName || ""}
          onChange={(e) =>
            setInputData((prev) => ({
              ...prev,
              questionName: e.target.value,
            }))
          }
          className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
        />
      </div>
      <div className="flex flex-col gap-[10px]">
        <label className="text-[#333] text-[14px] font-[500]">
          Question Type
        </label>
        <select
          required
          value={inputData?.questionType || ""}
          onChange={(e) => handleQuestionTypeChange(e.target.value)}
          className="border border-gray-300 rounded-md pl-4 pr-10 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] font-[400] cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
        >
          <option value="">Select Question Type</option>
          {QUESTION_TYPES.map((type) => (
            <option value={type} key={type}>
              {type}
            </option>
          ))}
        </select>
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-[#1a1a1a] text-[14px] font-[500]">
          Question Text
        </label>
        <textarea
          rows="4"
          required
          value={inputData?.questionText || ""}
          onChange={(e) =>
            setInputData((prev) => ({
              ...prev,
              questionText: e.target.value,
            }))
          }
          placeholder="Enter qualification question text"
          className="w-full border border-gray-300 rounded-md pl-4 pt-3 pr-4 pb-3 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all resize-none text-[#1a1a1a] text-[14px] hover:border-gray-400"
        />
      </div>
      {isChoiceType(inputData?.questionType) ? renderOptionsEditor() : null}
      <div className="flex flex-col gap-[10px]">
        <h1 className="text-[#000] font-[500] text-[14px]">Status</h1>
        <div className="flex items-center gap-8">
          {["active", "inactive"].map((status) => (
            <label
              key={status}
              className="flex items-center gap-2 cursor-pointer"
            >
              <input
                type="radio"
                name="questionStatus"
                checked={inputData?.questionStatus === status}
                onChange={() =>
                  setInputData((prev) => ({
                    ...prev,
                    questionStatus: status,
                  }))
                }
                className="accent-[#0226BE] w-[15px] h-[15px]"
              />
              <span className="text-[#666] text-[12px] font-[400] capitalize">
                {status}
              </span>
            </label>
          ))}
        </div>
      </div>
    </>
  );

  //GENERATE EXCEL FILE:
  const [xlData, setXlData] = useState([]);
  const generateExcelFile = (orgData) => {
    let generateData = [];
    orgData?.forEach((data) => {
      const options = data?.options?.map((d) => `${d}\n`).join(" ");
      generateData.push({
        "Qualification Name": data?.questionName || "-",
        Question: data?.questionText,
        "Qualification Type": data?.questionType,
        Category: "Custom",
        Visibility: "Public",
        "Current Usage": 0,
        Status: data?.questionStatus,
        Options: options,
      });
    });
    setXlData(generateData);
  };

  useEffect(() => {
    if (selectRows?.length) {
      generateExcelFile(selectRows);
    } else {
      generateExcelFile(myQuestions?.data);
    }
  }, [selectRows?.length]);

  //DOWNLOAD TO EXCEL DATA:
  const DownloadToExcel = () => {
    var wb = utils.book_new(),
      ws = utils.json_to_sheet(xlData);
    utils.book_append_sheet(wb, ws, "Sheet1");
    setSelectRows([]);
    writeFile(wb, `Questions.xlsx`);
    setSnackbar({
      open: true,
      severity: "success",
      msg: "Excel Sheet Downloaded!",
    });
  };

  // pagination function
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage2 = (event, newPage) => {
    setMyQuestionsPage(newPage);
  };
  const handleChangeRowsPerPage2 = (event) => {
    setMyQuestionsRowsPerPage(parseInt(event.target.value, 10));
    setMyQuestionsPage(0);
  };
  //DELETE QUESTION:
  const deleteQuestion = async (e, id) => {
    e.preventDefault();
    try {
      await axios.delete(`${BASE_URL}/question?id=${id}`).then(() => {
        queryClient.invalidateQueries(["myQuestions", user?.organizationId]);
        setSelectRows([]);
        setDeleteModal(false);

        setSnackbar({
          open: true,
          severity: "success",
          msg: "Question Deleted Successfully!",
        });
      });
    } catch (error) {
      console.log("Unable to delete question");
      setSelectRows([]);
      setDeleteModal(false);
      setSnackbar({
        open: true,
        severity: "error",
        msg: "Something went wrong!",
      });
    }
  };

  // console.log(qualifiOptions);
  // console.log(myQuestions, myQuestionsLoading, myQuestionsError);
  return (
    <div className="w-full flex flex-col gap-6 py-6">
      <div className="w-full flex items-center justify-between pb-4 border-b border-gray-200">
        <div>
          <h1 className="text-[#0226BE] text-[28px] font-[600] mb-1">
            Qualification Library
          </h1>
          <p className="text-gray-600 text-[14px]">Browse and manage qualification questions</p>
        </div>
        <button
          className="bg-[#0226BE] text-white py-2.5 px-5 text-[14px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors"
          onClick={(e) => handleOpen("qualification")}
        >
          Create New Qualification
        </button>
      </div>
      {/* filters row */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <select
            className="h-[44px] px-4 pr-10 text-[#1a1a1a] text-[14px] font-[500] bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
            value={filters?.type || ""}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, type: e.target.value }))
            }
          >
            <option value="">All Question Type</option>
            {[
              "Single Punch",
              "Multi Punch",
              "Numeric - Open-end",
              "Text - Open-end",
            ]?.map((d, key) => (
              <option value={d} key={key}>
                {d}
              </option>
            ))}
          </select>
          {(filters?.type || filters?.text) && (
            <button
              className="text-[14px] text-[#0226BE] font-[500] hover:underline px-3"
              onClick={(e) => setFilters({})}
            >
              Clear filters
            </button>
          )}
        </div>
        <div className="w-full max-w-[400px] relative">
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md focus:outline-none h-[44px] pl-11 pr-4 text-[14px] focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all hover:border-gray-400 placeholder:text-gray-400"
            placeholder="Search question text..."
            value={filters?.text || ""}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, text: e.target.value }))
            }
          />
          <span className="absolute top-1/2 -translate-y-1/2 left-3.5 text-gray-400">
            <AiOutlineSearch size={18} />
          </span>
        </div>
      </div>
      {/* table  */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="w-full border-b border-gray-200 flex items-center gap-[60px] px-6 py-3">
          {["Question Library", "My Questions"]?.map((data, ind) => (
            <h1
              key={ind}
              className={`text-[#666] text-[16px] font-[500] cursor-pointer transition-all ease-linear pb-2 ${
                tab == ind &&
                `text-[#0226BE] font-[600] border-b-2 border-[#0226BE]`
              }`}
              onClick={(e) => {
                setTab(ind);
              }}
            >
              {data}
            </h1>
          ))}
        </div>
        {tab == 1 && selectRows?.length ? (
          <div className="w-full border-b border-gray-200 flex items-center justify-between px-6 py-4 bg-blue-50">
            <div className="flex items-center gap-4">
              <input
                type="checkbox"
                className="w-4 h-4 cursor-pointer accent-[#0226BE]"
                checked={selectRows?.length === myQuestions?.data?.length && myQuestions?.data?.length > 0}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectRows(myQuestions?.data);
                  } else {
                    setSelectRows([]);
                  }
                }}
              />
              <span className="text-[14px] text-[#0226BE] font-[500]">
                {selectRows?.length} selected
              </span>
            </div>
            <div className="flex items-center gap-3">
              {selectRows?.length == 1 && (
                <button
                  className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                  onClick={() => openEditQuestion(selectRows?.[0])}
                  title="Edit"
                >
                  <MdOutlineModeEditOutline size={20} className="text-gray-600" />
                </button>
              )}
              <button
                className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                onClick={(e) => {
                  DownloadToExcel();
                }}
                title="Download"
              >
                <MdDownload size={20} className="text-gray-600" />
              </button>
              <button
                className="p-2 hover:bg-red-50 rounded-md transition-colors"
                onClick={(e) => {
                  setDeleteModal(true);
                }}
                title="Delete"
              >
                <MdDelete size={20} className="text-red-600" />
              </button>
            </div>
          </div>
        ) : null}

        <div className="w-full overflow-x-auto containerScroll">
            <table
              className="whitespace-nowrap text-left w-full"
              id="table-to-xls-DATA"
            >
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    {tab == 1 ? (
                      <input
                        type="checkbox"
                        className="w-4 h-4 cursor-pointer accent-[#0226BE]"
                        checked={selectRows?.length === myQuestions?.data?.length && myQuestions?.data?.length > 0}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectRows(myQuestions?.data);
                          } else {
                            setSelectRows([]);
                          }
                        }}
                      />
                    ) : null}
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Qualification Name
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Question
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Qualification Type
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Status
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Actions
                  </th>
                </tr>
              </thead>
              {tab === 0 ? (
                <tbody>
                  {libraryQuestionsLoading ? (
                    <>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((d, i) => (
                        <tr key={i}>
                          <td className="p-3 text-[#667085]  ">
                            <Skeleton className="w-[50px] h-[30px] rounded-md" />
                          </td>
                          {[1, 2, 3, 4, 5]?.map((dd, ii) => (
                            <td className="p-3 ">
                              <Skeleton
                                key={ii}
                                className="w-[170px] h-[30px] rounded-md"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </>
                  ) : libraryQuestionsError ? (
                    <tr>
                      <td colSpan={6}>
                        <div className="w-full text-center py-6 text-[#666] font-[500] text-[18px] flex items-center justify-center flex-col space-y-5 h-[250px]">
                          <h1 className="text-[#e12121] text-[14px] ml-8 font-[300] tracking-wide flex gap-[10px] items-center">
                            Something went wrong !
                          </h1>
                        </div>
                      </td>
                    </tr>
                  ) : libraryQuestions?.data?.length ? (
                    libraryQuestions?.data?.map((data, ind) => (
                      <tr
                        className="border-b border-gray-100 transition-all hover:bg-blue-50 cursor-pointer"
                        key={ind}
                      >
                        <td className="px-4 py-4"></td>
                        <td className="px-4 py-4 text-[#1a1a1a] font-[500] text-[14px]">
                          {data?.questionName}
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          <p className="max-w-[400px] break-words whitespace-break-spaces">
                            {data?.questionText}
                          </p>
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          {data?.questionType}
                        </td>
                        <td className="px-4 py-4">
                          {data?.questionStatus === "active" ? (
                            <span className="inline-flex items-center px-3 py-1 bg-green-50 text-green-700 text-[12px] font-[500] rounded-full border border-green-200">
                              Active
                            </span>
                          ) : (
                            <span className="inline-flex items-center px-3 py-1 bg-orange-50 text-orange-700 text-[12px] font-[500] rounded-full border border-orange-200">
                              Inactive
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-4">
                          <button
                            className="p-1.5 hover:bg-gray-100 rounded-md transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpen("preview");
                              setPreviewData(data);
                            }}
                            title="Preview"
                          >
                            <AiOutlineEye size={18} className="text-gray-600" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>
                        <div className="w-full text-center py-6 text-[#666] font-[500] text-[18px] flex items-center justify-center flex-col space-y-5 h-[250px]">
                          <NoData msg={"Try Changing the filters"} />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              ) : (
                <tbody>
                  {myQuestionsLoading ? (
                    <>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((d, i) => (
                        <tr key={i}>
                          <td className="p-3 text-[#667085]  ">
                            <Skeleton className="w-[50px] h-[30px] rounded-md" />
                          </td>
                          {[1, 2, 3, 4, 5]?.map((dd, ii) => (
                            <td className="p-3 ">
                              <Skeleton
                                key={ii}
                                className="w-[170px] h-[30px] rounded-md"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </>
                  ) : myQuestionsError ? (
                    <tr>
                      <td colSpan={6}>
                        <div className="w-full text-center py-6 text-[#666] font-[500] text-[18px] flex items-center justify-center flex-col space-y-5 h-[250px]">
                          <h1 className="text-[#e12121] text-[14px] ml-8 font-[300] tracking-wide flex gap-[10px] items-center">
                            Something went wrong !
                          </h1>
                        </div>
                      </td>
                    </tr>
                  ) : myQuestions?.data?.length ? (
                    myQuestions?.data?.map((data, ind) => (
                      <tr
                        className="border-b border-gray-100 transition-all hover:bg-blue-50"
                        key={ind}
                      >
                        <td className="px-4 py-4" onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            className="w-4 h-4 cursor-pointer accent-[#0226BE]"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            checked={selectRows?.some(
                              (se) => se?._id == data?._id
                            )}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectRows((prev) => [...prev, data]);
                              } else {
                                setSelectRows(
                                  selectRows?.filter(
                                    (sc) => sc?._id !== data?._id
                                  )
                                );
                              }
                            }}
                          />
                        </td>
                        <td className="px-4 py-4 text-[#1a1a1a] font-[500] text-[14px]">
                          {data?.questionName || "-"}
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          <p className="max-w-[400px] break-words whitespace-break-spaces">
                            {data?.questionText}
                          </p>
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          {data?.questionType}
                        </td>
                        <td className="px-4 py-4">
                          {data?.questionStatus === "active" ? (
                            <span className="inline-flex items-center px-3 py-1 bg-green-50 text-green-700 text-[12px] font-[500] rounded-full border border-green-200">
                              Active
                            </span>
                          ) : (
                            <span className="inline-flex items-center px-3 py-1 bg-orange-50 text-orange-700 text-[12px] font-[500] rounded-full border border-orange-200">
                              Inactive
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex items-center gap-1">
                            <button
                              className="p-1.5 hover:bg-gray-100 rounded-md transition-colors"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOpen("preview");
                                setPreviewData(data);
                              }}
                              title="Preview"
                            >
                              <AiOutlineEye size={18} className="text-gray-600" />
                            </button>
                            <button
                              className="p-1.5 hover:bg-blue-50 rounded-md transition-colors"
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditQuestion(data);
                              }}
                              title="Edit question type, text, and options"
                            >
                              <MdOutlineModeEditOutline
                                size={18}
                                className="text-[#0226BE]"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>
                        <div className="w-full text-center py-6 text-[#666] font-[500] text-[18px] flex items-center justify-center flex-col space-y-5 h-[250px]">
                          <NoData
                            msg={
                              <h1
                                className="text-primary font-[500] underline underline-offset-4 decoration-2 cursor-pointer"
                                onClick={(e) => handleOpen("qualification")}
                              >
                                Add new
                              </h1>
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
              {tab === 0 ? (
                <CustomTablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  sx={{ fontSize: "10px" }}
                  count={libraryQuestions?.pagination?.totalRecords || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  componentsProps={{
                    select: {
                      "aria-label": "rows per page",
                    },
                    actions: {
                      showFirstButton: true,
                      showLastButton: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : (
                <CustomTablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  sx={{ fontSize: "10px" }}
                  count={myQuestions?.pagination?.totalRecords || 0}
                  rowsPerPage={myQuestionsRowsPerPage}
                  page={myQuestionsPage}
                  componentsProps={{
                    select: {
                      "aria-label": "rows per page",
                    },
                    actions: {
                      showFirstButton: true,
                      showLastButton: true,
                    },
                  }}
                  onPageChange={handleChangePage2}
                  onRowsPerPageChange={handleChangeRowsPerPage2}
                />
              )}
            </table>
          </div>
        </div>
      {/* preview modal*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalsOpen?.preview}
        onClose={(e) => handleClose("preview")}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalsOpen?.preview}>
          <Box sx={style}>
            <div className="w-full flex items-center flex-col">
              <div className="w-full py-5 px-6 border-b border-gray-200 text-left relative">
                <h1 className="text-[#0226BE] text-[20px] font-[600]">
                  Question Preview
                </h1>
                <button
                  className="absolute top-4 right-4 p-1.5 hover:bg-gray-100 rounded-full cursor-pointer transition-colors"
                  onClick={(e) => handleClose("preview")}
                >
                  <RxCross2 size={18} className="text-gray-600" />
                </button>
              </div>

              <div className="w-full  p-5 flex flex-col gap-[20px]">
                <h1 className="text-[#000] text-[20px] font-[500] inter">
                  {previewData?.questionText}
                </h1>

                {previewData?.questionType == "Multi Punch" ||
                previewData?.questionType == "Single Punch" ? (
                  <div className="w-full  max-h-[250px] overflow-y-auto containerScroll flex flex-col gap-[8px]">
                    {previewData?.options?.map((data, ind) => (
                      <div
                        className="w-full pr-2 flex items-center gap-[12px] my-2 "
                        key={ind}
                      >
                        {previewData?.questionType == "Multi Punch" ? (
                          <input
                            type="checkbox"
                            name={data}
                            id={data}
                            className="w-[18px] h-[18px]"
                          />
                        ) : (
                          <input
                            type="radio"
                            name="singlePunchOption"
                            id={data}
                            className="w-[18px] h-[18px]"
                          />
                        )}

                        <label
                          htmlFor={data}
                          className="text-[16px] font-[400] text-[#333] w-[90%] cursor-pointer capitalize"
                        >
                          {data}
                        </label>
                      </div>
                    ))}
                  </div>
                ) : (
                  <input
                    type={`${
                      previewData?.questionType == "Numeric - Open-end"
                        ? "number"
                        : "text"
                    }`}
                    step="any"
                    placeholder="Add Text"
                    className="w-[60%] border border-[#E0E0E0]  rounded-[6.5px] pl-3 text-[#666] font-[400] text-[12px] h-[40px] mt-3 bg-[#F9F9FF]"
                  />
                )}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* create / edit modal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalsOpen?.qualification}
        onClose={(e) => handleClose("qualification")}
        closeAfterTransition
        disableEnforceFocus
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalsOpen?.qualification}>
          <Box sx={{ ...style, width: 600, maxHeight: "90vh", overflow: "hidden" }}>
            <div className="w-full flex items-center flex-col max-h-[90vh]">
              <div className="w-full py-5 px-6 border-b border-gray-200 text-left relative shrink-0">
                <h1 className="text-[#0226BE] text-[20px] font-[600]">
                  {inputData?.edit ? "Edit Qualification" : "Create Qualification"}
                </h1>
                <p className="text-[13px] text-gray-500 mt-1">
                  {inputData?.edit
                    ? "Update question type, question text, and options."
                    : "Add a new qualification question to My Questions."}
                </p>
                <button
                  type="button"
                  className="absolute top-4 right-4 p-1.5 hover:bg-gray-100 rounded-full cursor-pointer transition-colors"
                  onClick={(e) => handleClose("qualification")}
                >
                  <RxCross2 size={18} className="text-gray-600" />
                </button>
              </div>

              <form
                className="w-full py-5 px-6 flex flex-col gap-5 overflow-y-auto containerScroll"
                onSubmit={inputData?.edit ? editQualification : handleSubmit}
              >
                {inputData?.edit
                  ? renderEditQualificationForm()
                  : renderCreateQualificationPage()}
                <div className="flex justify-end gap-3 pt-2 shrink-0">
                  {!inputData?.edit ? (
                    <button
                      onClick={() => setCreateQualiPage((prev) => prev - 1)}
                      type="button"
                      className={`border-2 border-gray-300 rounded-md py-2.5 px-5 text-[14px] font-[500] text-gray-700 hover:bg-gray-50 transition-colors ${
                        createQualiPage < 1 ? "hidden" : ""
                      }`}
                    >
                      Back
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => handleClose("qualification")}
                      className="border-2 border-gray-300 rounded-md py-2.5 px-5 text-[14px] font-[500] text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                  )}
                  <button
                    type="submit"
                    disabled={savingQuestion}
                    className="bg-[#0226BE] text-white text-[14px] font-[500] rounded-md py-2.5 px-5 hover:bg-[#021ea8] transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2"
                  >
                    {savingQuestion ? (
                      <>
                        <CircularProgress size={16} className="text-white" />
                        Saving...
                      </>
                    ) : inputData?.edit ? (
                      "Save Changes"
                    ) : createQualiPage === 3 ? (
                      "Finish"
                    ) : (
                      "Next"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* DELETE MODAL */}
      <DeleteModal
        open={deleteModal}
        handleClose={handleCloseModal}
        text={
          selectRows?.length
            ? selectRows?.map((data) => data?.questionName)
            : myQuestions?.data?.map((data) => data?.questionName)
        }
        handleClick={(e) => {
          if (selectRows?.length) {
            selectRows?.map((data) => {
              deleteQuestion(e, data?._id);
            });
          } else {
            myQuestions?.data?.map((data) => {
              deleteQuestion(e, data?._id);
            });
          }
        }}
      />
    </div>
  );
};

export default Qualification;
